import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About'; // Hakkımızda sayfası
import Register from './pages/Register';
import Editor from './pages/Editor/Editor';
import Header from './components/Header';
import Footer from './components/Footer';
import Login from './pages/Login';
import AdminPanel from './pages/admin/Admin';
import EditorGiris from './components/EditorGiris';
import CommentSection from './components/CommentSection';
import BlogDetail from './components/BlogDetail';
import AcilisOran from './pages/Oran/AcilisOran';
import Urunler from './pages/Urunler'; // Ürünler sayfası
import SatinAl from './pages/SatinAl';
import KapanisOran from './pages/Oran/KapanisOran';
import Oranlar from './pages/Oran/Oranlar';
import Profile from './components/Profile';
import UyelikSozlesmesi from './components/UyelikSozlesmesi';
import Kazananlar from './pages/Editor/Kazananlar';
import KazananGiris from './components/KazananGiris';
import AcilisReyting from './pages/Oran/AcilisReyting';
import KapanisReyting from './pages/Oran/KapanisReyting';
import Reytingler from './pages/Oran/Reytingler';
import ThemeToggleButton from './components/ThemeToggleButton';
import YabanciKapanis from './pages/YabanciKapanis';
import YabanciAcilis from './pages/YabanciAcilis';
import YerelKapanis from './pages/YerelKapanis';
import TipsTest from './pages/TipsTest';
import TipsTest2 from './pages/TipsTest2';
import NexoraAnaliz from './pages/NexoraAnaliz';

function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole')); // Rol bilgisi için state

    useEffect(() => {
        setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
        setUserRole(localStorage.getItem('userRole')); // Rol bilgisini localStorage'dan al
    }, []);

    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route
                    path="/kapanisoran"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <KapanisOran /> : <Navigate to="/login" />}
                />
                <Route
                    path="/acilisoran"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <AcilisOran /> : <Navigate to="/login" />}
                />
                <Route
                    path="/acilisreyting"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <AcilisReyting /> : <Navigate to="/login" />}
                />

                <Route
                    path="/kapanisreyting"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <KapanisReyting /> : <Navigate to="/login" />}
                />
                <Route
                    path="/oranlar"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <Oranlar /> : <Navigate to="/login" />}
                />
                <Route
                    path="/reytingler"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <Reytingler /> : <Navigate to="/login" />}
                />
                {/* Giriş zorunluluğu kaldırıldı */}
                <Route path="/about" element={<About />} />
                <Route path="/urunler" element={<Urunler />} />

                {/* <Route
    path="/kazananlar"
    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <Kazananlar /> : <Navigate to="/login" />}
/>
<Route
    path="/kazanangiris"
    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user') ? <KazananGiris /> : <Navigate to="/login" />}
/> */}

                <Route
                    path="/editor"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <Editor /> : <Navigate to="/login" />}
                />
                <Route
                    path="/commentsection"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <CommentSection /> : <Navigate to="/login" />}
                />
                <Route
                    path="/blog/:id"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <BlogDetail /> : <Navigate to="/login" />}
                />
                <Route path="/satinal" element={isLoggedIn ? <SatinAl /> : <Navigate to="/login" />} />
                <Route path="/register" element={<Register />} />
                <Route
                    path="/admin"
                    element={isLoggedIn && userRole === 'admin' ? <AdminPanel /> : <Navigate to="/login" />}
                />
                <Route
                    path="/editorgiris"
                    element={isLoggedIn && (userRole === 'editor' || userRole === 'admin') ? <EditorGiris /> : <Navigate to="/login" />}
                />
                <Route path="/profile" element={isLoggedIn ? <Profile /> : <Navigate to="/login" />} />
                {/* Üyelik Sözleşmesi sayfası eklendi */}
                <Route path="/uyeliksozlesmesi" element={<UyelikSozlesmesi />} />


                {/* Filtre Tablo */}
                <Route path="/yerelkapanis" element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <YerelKapanis /> : <Navigate to="/login" />} />
                <Route path="/yabanciacilis" element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <YabanciAcilis /> : <Navigate to="/login" />} />
                <Route path="/yabancikapanis" element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') ? <YabanciKapanis /> : <Navigate to="/login" />} />
                <Route path="/acilisanaliz" element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user') ? <TipsTest /> : <Navigate to="/login" />} />
                <Route path="/zetaanaliz" element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user') ? <TipsTest2 /> : <Navigate to="/login" />} />
                <Route path="/nexoraanaliz" element={isLoggedIn && (userRole === 'editor' || userRole === 'admin' || userRole === 'user') ? <NexoraAnaliz /> : <Navigate to="/login" />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
